export default function MySQL_IFNULL() {
  return (
    <div>
      <h2>MySQL_IFNULL</h2>    </div>
  );
}